(ns client-onboard.common
  (:require [very.re-frame.core :as rf]
            [css.core :refer [defstyled get-theme]]
            [css.icons :as icon]
            [css.form :as form]
            [css.vars :as vars]
            [cljss.core :as cljss]))

(defstyled onboard-loc-wrapper-s :div
  {:display "grid"
   :grid-template-columns "repeat(4, min-content)"
   :justify-content "center"
   :grid-column-gap "2rem"
   :position "absolute"
   :top "0"
   :margin "auto"
   :right "0"
   :left "0"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-column-gap "1rem"}}})

(defstyled risk-loc-s :div
  {:width "5.2rem"
   :height "5.2rem"
   :background-image (with-meta #(str "url(/assets/icons/onboarding/risk-" (inc %) "-8.svg)") :location)
   :background-repeat "no-repeat"
   :background-size "contain"
   :background-position "center"
   :position "relative"})

(defstyled risk-loc-inactive-s :div
  {:width "5.2rem"
   :height "5.2rem"
   :background-image "url(/assets/icons/onboarding/risk-8-8.svg)"
   :background-repeat "no-repeat"
   :background-size "contain"
   :background-position "center"
   :position "relative"})

(defstyled goal-loc-s :div
  {:width "5.2rem"
   :height "5.2rem"
   :background-image (with-meta #(str "url(/assets/icons/onboarding/goal-" % "-2.svg)") :location)
   :background-repeat "no-repeat"
   :background-size "contain"
   :background-position "center"
   :position "relative"})

(defstyled goal-loc-inactive-s :div
  {:width "5.2rem"
   :height "5.2rem"
   :background-image (with-meta #(cond
                                   (= % "risk") "url(/assets/icons/onboarding/goal-0-2.svg)"
                                   (or (= % "finances") (= % "new")) "url(/assets/icons/onboarding/goal-2-2.svg)") :step)
   :background-repeat "no-repeat"
   :background-size "contain"
   :background-position "center"
   :position "relative"})

(defstyled finances-loc-s :div
  {:width "5.2rem"
   :height "5.2rem"
   :background-image (with-meta #(str "url(/assets/icons/onboarding/finances-" % "-5.svg)") :location)
   :background-repeat "no-repeat"
   :background-size "contain"
   :background-position "center"
   :position "relative"})

(defstyled finances-loc-inactive-s :div
  {:width "5.2rem"
   :height "5.2rem"
   :background-image (with-meta #(cond
                                   (= % "new") "url(/assets/icons/onboarding/finances-5-5.svg)"
                                   (or (= % "risk") (= % "goal")) "url(/assets/icons/onboarding/finances-0-5.svg)") :step)
   :background-repeat "no-repeat"
   :background-size "contain"
   :background-position "center"
   :position "relative"})

(defstyled new-loc-s :div
  {:width "5.2rem"
   :height "5.2rem"
   :background-image (with-meta #(str "url(/assets/icons/onboarding/new-" % "-2.svg)") :location)
   :background-repeat "no-repeat"
   :background-size "contain"
   :background-position "center"
   :position "relative"})

(defstyled new-loc-inactive-s :div
  {:width "5.2rem"
   :height "5.2rem"
   :background-image (with-meta #(if (or (= % "risk") (= % "goal") (= % "finances"))
                                   "url(/assets/icons/onboarding/new-0-2.svg)"
                                   "url(/asstes/icons/onboarding/new-2-2.svg)") :step)
   :background-repeat "no-repeat"
   :background-size "contain"
   :background-position "center"
   :position "relative"})

(defstyled loc-icon-s :div
  {:width "1.5rem"
   :height "1.5rem"
   :background-image (with-meta #(str "url(/assets/icons/onboarding/" % ".svg)") :icon)
   :background-repeat "no-repeat"
   :background-size "contain"
   :position "absolute"
   :left "0"
   :right "0"
   :bottom "0"
   :top "0"
   :margin "auto"})

(defn onboarding-header [{:keys [location step]}]
  [onboard-loc-wrapper-s
   (if (= step "risk")
     [risk-loc-s {:step step
                  :location location}
      [loc-icon-s {:icon step}]]
     [risk-loc-inactive-s {:step step}
      [loc-icon-s {:icon "risk"}]])
   (if (= step "goal")
     [goal-loc-s {:step step
                  :location location}
      [loc-icon-s {:icon "goal"}]]
     [goal-loc-inactive-s {:step step}
      [loc-icon-s {:icon "goal"}]])
   (if (= step "finances")
     [finances-loc-s {:step step
                      :location location}
      [loc-icon-s {:icon "finances"}]]
     [finances-loc-inactive-s {:step step}
      [loc-icon-s {:icon "finances"}]])
   (if (= step "new")
     [new-loc-s {:step step
                 :location location}
      [loc-icon-s {:icon "new"}]]
     [new-loc-inactive-s {:step step}
      [loc-icon-s {:icon "new"}]])])
